import React, { useState } from 'react';
import axios from 'axios';

// webOS Players have playback preferences, but no Android agent/startup settings.
export default function PlayerOnlySettings({ device, onSaved }) {
  const [settings, setSettings] = useState({});
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const save = async () => {
    if (busy) return;
    setBusy(true); setError(''); setMessage('');
    try {
      await axios.post('/api/devices/update-settings', { deviceId: device.id, settings }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, timeout: 20000,
      });
      setMessage('Player settings saved.'); onSaved?.();
    } catch (failure) { setError(failure.response?.data?.message || 'Could not save Player settings.'); }
    finally { setBusy(false); }
  };
  return <fieldset disabled={busy}>
    <legend>Player settings</legend>
    <p>Suitestream Player · playback only</p>
    <label>Fade duration (seconds)<input type="number" min="0" max="30" value={settings.fade_duration ?? device.fade_duration ?? 5}
      onChange={(event) => setSettings((value) => ({ ...value, fade_duration: Number(event.target.value) }))} /></label>
    <label>Watermark size<select value={settings.watermark_size ?? device.watermark_size ?? 'medium'}
      onChange={(event) => setSettings((value) => ({ ...value, watermark_size: event.target.value }))}>
      {['small', 'medium', 'large'].map((value) => <option key={value}>{value}</option>)}
    </select></label>
    <label>Watermark position<select value={settings.watermark_position ?? device.watermark_position ?? 'top_right'}
      onChange={(event) => setSettings((value) => ({ ...value, watermark_position: event.target.value }))}>
      {['top_left', 'top_right', 'bottom_left', 'bottom_right'].map((value) => <option key={value}>{value}</option>)}
    </select></label>
    <button type="button" disabled={!Object.keys(settings).length} onClick={save}>Save Player Settings</button>
    {message && <p role="status">{message}</p>}{error && <p role="alert">{error}</p>}
  </fieldset>;
}
